import { render, staticRenderFns } from "./EmployeeLeaveRightForm.vue?vue&type=template&id=338c1850"
import script from "./EmployeeLeaveRightForm.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveRightForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports